export default window => {
  if (!Function.prototype.bind) {
    return true
  }

  const {languages} = window.navigator
  if (languages && languages.length === 0) {
    return true
  }

  let stack
  try {
    null[0]()
  } catch (e) {
    stack = e.stack
  }

  if (stack && /ph\x61n\x74om|n\x6fde/i.test(stack)) {
    return true
  }

  return false
}


// WEBPACK FOOTER //
// ./~/santa-main-r/src/main/lib/common/isSuspectedBot.js